<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" data-title="설정" :type="'home'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section>
          <div v-if="userInfo" class="appSet">
            <p class="tit">로그인 설정</p>
            <div class="appBox">
              <div class="item">
                <span class="tit">{{ userInfo.userId }}</span>
                <button type="button" class="btn_g round s fr" @click="logout">로그아웃</button>
              </div>
              <div class="item">
                <span class="tit">자동로그인</span>
                <div class="switchIpt fr">
                  <input type="checkbox" name="switch0" id="switch0" v-model="autoLogin" />
                  <label for="switch0"><span class="blind">자동로그인 ON/OFF</span></label>
                </div>
              </div>
            </div>
          </div>

          <div class="appSet">
            <p class="tit">알림 설정</p>
            <div class="appBox">
              <div class="item">
                <span class="tit">푸시 알림 동의</span>
                <div class="switchIpt fr">
                  <input type="checkbox" name="switch1" id="switch1_0" v-model="pushYn" />
                  <label for="switch1_0"><span class="blind">푸시 알림 동의 ON/OFF</span></label>
                </div>
              </div>
              <div class="item">
                <span class="tit">마케팅 정보 알림 수신</span>
                <div class="switchIpt fr">
                  <input type="checkbox" name="switch1" id="switch1_1" v-model="marketingYn" />
                  <label for="switch1_1"><span class="blind">마케팅 정보 알림 수신 ON/OFF</span></label>
                </div>
              </div>
              <!-- <div class="item">
                <span class="tit">선택적 수집 정보 동의</span>
                <div class="switchIpt fr">
                  <input type="checkbox" name="switch1" id="switch1_2" v-model="selAuthYn" />
                  <label for="switch1_2"><span class="blind">선택적 수집 정보 동의 ON/OFF</span></label>
                </div>
              </div> -->
            </div>
          </div>

          <div class="appSet">
            <p class="tit">버전정보</p>
            <div class="appBox">
              <div class="item">
                <span class="tit">Well - {{ appVersion }}</span>
                <span class="txtM fr">최신버전 입니다.</span>
              </div>
            </div>
          </div>
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
    <MessagePop v-if="messagePop" @close="messagePop = false">
      <p v-html="msg"></p>
    </MessagePop>

    <ConfirmPop v-if="confirmPop" @confirm="confirmAutoLogin" @cancel="closeAutoLogin" @close="closeAutoLogin">
      <p v-html="msg"></p>
    </ConfirmPop>

    <ConfirmPop v-if="confirmPop2" @confirm="confirmSelAuthYn" @cancel="closeSelAuthYn" @close="closeSelAuthYn">
      <p v-html="msg"></p>
    </ConfirmPop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import ConfirmPop from '@/components/popup/ConfirmPop';
export default {
  name: 'Setting',
  components: { ConfirmPop },
  data() {
    return {
      init: false,
      autoLogin: true,
      pushYn: false,
      marketingYn: false,
      selAuthYn: true,
      userInfo: false,
      userId: null,
      msg: '',
      messagePop: false,
      confirmPop: false,
      confirmPop2: false,
      uuid: '',
      fcmToken: '',
      appVersion: '1.0',
    };
  },
  mounted() {
    // 로그인 유무
    if (JwtService.getToken()) {
      this.userInfo = JwtService.getUserInfo();
      this.userId = JwtService.getUserInfo().userId;
    }

    window.getUUID();
    setTimeout(() => {
      this.uuid = window.getUUIDValue();
    }, 100);

    // 앱버전
    window.getAppVersion();
    setTimeout(
      function() {
        this.appVersion = window.getAppVersionValue();
      }.bind(this),
      100,
    );

    // fcmToken
    window.getFcmToken();
    setTimeout(
      function() {
        this.fcmToken = window.getFcmTokenValue();
      }.bind(this),
      200,
    );
  },
  watch: {
    async uuid() {
      const params = {
        request: {
          uuid: this.uuid,
        },
      };
      await ApiService.service('POST', '/common/service/setting', params)
        .then(({ data }) => {
          console.log(data);
          if (JwtService.getToken()) {
            this.pushYn = data.result.userPushYn == 'Y' ? true : false;
            this.marketingYn = data.result.userMarketingYn == 'Y' ? true : false;
            this.selAuthYn = data.result.selAuthYn == 'Y' ? true : false;
          } else {
            this.pushYn = data.result.pushYn == 'Y' ? true : false;
            this.marketingYn = data.result.marketingYn == 'Y' ? true : false;
            this.selAuthYn = data.result.selAuthYn == 'Y' ? true : false;
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });

      this.init = true;
    },
    autoLogin() {
      if (!this.autoLogin) {
        this.msg = `자동 로그인을 해지하시겠습니까?`;
        this.confirmPop = true;
      } else {
        localStorage.setItem('auto_login', true);
      }
    },
    pushYn() {
      if (this.init) {
        // 해당 메세지 마케팅 수신 정보 용이며 앱푸쉬와는 관련 없다 (정보보안부서 쪽 이슈) 20201126 최재니
        //const time = this.getToastTime();
        //if (this.pushYn) this.msg = '광고성 정보(PUSH) 알림 받기를 동의하셨습니다. (' + time + ')';
        //else this.msg = '광고성 정보(PUSH) 알림 받기를 거부하셨습니다. (' + time + ')';
        this.request();
        //window.toast(this.msg);
      }
    },
    marketingYn() {
      if (this.init) {
        const time = this.getToastTime();
        if (this.marketingYn) this.msg = `광고성 정보(PUSH) 알림 받기를 동의하셨습니다. (${time})`;
        else this.msg = `광고성 정보(PUSH) 알림 받기를  거부하셨습니다. (${time})`;
        this.request();
        window.toast(this.msg);
      }
    },
    // selAuthYn() {
    //   if (this.selAuthYn) {
    //     this.msg = `사진업로드를 위해 카메라/저장소<br/>접근권한을 허용하시겠습니까?`;
    //     this.confirmPop2 = true;
    //   }
    // },
  },
  methods: {
    logout() {
      JwtService.logout();
      this.$router.replace('/');
    },
    closeAutoLogin() {
      this.confirmPop = false;
      this.autoLogin = !this.autoLogin;
    },
    confirmAutoLogin() {
      localStorage.removeItem('auto_login');
      this.confirmPop = false;
    },
    // confirmSelAuthYn() {
    //   this.confirmPop2 = false;
    // },
    // closeSelAuthYn() {
    //   this.confirmPop2 = false;
    //   this.selAuthYn = !this.selAuthYn;
    // },
    getTime() {
      return this.$moment(new Date()).format('YYYYMMDD');
    },
    getToastTime() {
      return this.$moment(new Date()).format('YYYY-MM-DD');
    },
    request() {
      let osType = '';

      if (/Android/i.test(navigator.userAgent)) {
        osType = 'android';
      } else {
        osType = 'iphone';
      }

      const params = {
        request: {
          uuid: this.uuid,
          token: this.fcmToken,
          marketingDt: this.getTime(),
          marketingYn: this.marketingYn == true ? 'Y' : 'N',
          pushDt: this.getTime(),
          pushYn: this.pushYn == true ? 'Y' : 'N',
          selAuthDt: this.getTime(),
          selAuthYn: 'Y',
          userId: this.userId,
          osType: osType,
        },
      };
      console.log(params);
      ApiService.service('PUT', '/common/service/setting', params)
        .then(({ data }) => {
          console.log(data);
          if (!data.isSucceed) {
            this.msg = this.data.error;
            this.messagePop = true;
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
  },
};
</script>
